module.exports = __webpack_public_path__ + "media/assets/site_images/team/suporte-56c1b97036b680b3dcf888e32d194377.png";